import { getComposeStore } from 'owa-calendar-compose-store-manager';
import type { QuickComposeViewState } from 'owa-calendar-compose-types';
import { dismissUndoNotification } from 'owa-calendar-actions';
import { lazyDismissCalendarNotification } from 'owa-calendar-notification-bar';
import { orchestrator } from 'satcheljs';
import { UNDO_NOTIFICATION_ID } from './showUndoNotificationForCompose';

export default orchestrator(dismissUndoNotification, actionMessage => {
    const store = getComposeStore();

    // We need a check to know if the notification still presented because an error will occur if
    // you try to dismiss it and it does not exist.
    if ((store?.uiState as QuickComposeViewState)?.isUndoNotificationShown) {
        lazyDismissCalendarNotification.import().then(dismissAction => {
            dismissAction(UNDO_NOTIFICATION_ID);
        });
    }
});
